import React, { useState } from 'react'
import { withTranslation } from 'react-i18next'
import Button from '@material-ui/core/Button'
import { renderField, validate, isDebug } from './helpers'
import { contactInfoValidation } from '../../helpers/step-builder/validations-yup'

// eslint-disable-next-line react/prop-types
function DriverInfoFunc({ payload, setPayload, nextStep, isGuest, waiverContactModel, t }) {
  const [errors, setErrors] = useState({})
  const hd = {
    errors,
    payload,
    setPayload,
    t
  }
  setDebugPayload()

  const validation = contactInfoValidation(isGuest, t)

  const nextStepClick = async () => {
    const _errors = await validate(validation, payload)
    if (Object.keys(_errors).length === 0) {
      nextStep()
    }
    setErrors(_errors)
  }
  const buttonFunctions = { nextStepClick }

  return (
    <>
      <div className="flex flex-top">
        {
          // eslint-disable-next-line react/prop-types
          renderField(hd, waiverContactModel.firstName)
        }
        {
          // eslint-disable-next-line react/prop-types
          renderField(hd, waiverContactModel.lastName)
        }
      </div>
      <div className="flex flex-top">
        {
          // eslint-disable-next-line react/prop-types
          renderField(hd, waiverContactModel.email)
        }
        {
          // eslint-disable-next-line react/prop-types
          renderField(hd, waiverContactModel.phone)
        }
      </div>
      <div className="flex flex-top">
        {
          // eslint-disable-next-line react/prop-types
          renderField(hd, waiverContactModel.addressLine1)
        }
      </div>
      <div className="flex flex-top">
        {
          // eslint-disable-next-line react/prop-types
          renderField(hd, waiverContactModel.addressLine2)
        }
      </div>
      <div className="flex flex-top">
        {
          // eslint-disable-next-line react/prop-types
          renderField(hd, waiverContactModel.city)
        }
      </div>
      <div className="flex">
        {
          // eslint-disable-next-line react/prop-types
          renderField(hd, waiverContactModel.state)
        }
        {
          // eslint-disable-next-line react/prop-types
          renderField(hd, waiverContactModel.postalCode)
        }
        {
          // eslint-disable-next-line react/prop-types
          renderField(hd, waiverContactModel.country)
        }
      </div>
      {
        // eslint-disable-next-line react/prop-types
        renderField(hd, waiverContactModel.birthDate)
      }
      <div className="flex">
        {
          // eslint-disable-next-line react/prop-types
          renderField(hd, waiverContactModel.firstTimeRider)
        }
      </div>
      <div className="flex">
        {
          // eslint-disable-next-line react/prop-types
          renderField(hd, waiverContactModel.driverHasMotorcycleLicense)
        }
      </div>
      <div className="right">
        {waiverContactModel &&
          // eslint-disable-next-line react/prop-types
          waiverContactModel.buttons.map((button, ix) => (
            <Button
              variant={button.variant}
              color={button.color}
              size={button.size}
              className={button.className}
              onClick={buttonFunctions[button.clickFunc]}
              id={
                // eslint-disable-next-line react/prop-types
                waiverContactModel.label + '-' + button.label + '-' + ix.toString()
              }
              key={
                // eslint-disable-next-line react/prop-types
                waiverContactModel.label + '-' + button.label + '-' + ix.toString()
              }
            >
              {t(button.label)}
            </Button>
          ))}
      </div>
    </>
  )

  function setDebugPayload() {
    if (isDebug() && Object.keys(payload).length < 2) {
      setPayload({
        firstName: 'John',
        lastName: 'Scofield',
        email: 'john@scofield.info',
        phone: '1234123412',
        addressLine1: 'Kolima street',
        addressLine2: '45',
        city: 'Propolis',
        state: 'MN',
        postalCode: '123123',
        country: 'USA'
      })
    }
  }
}

export const DriverInfo = withTranslation()(DriverInfoFunc)
